import React, { createContext, useState, useEffect, useContext } from "react";
import { BeneficiariesService } from "../services/BeneficiariesService";
import { AuthContext } from "./AuthContext";

export const BeneficiariesContext = createContext();

export const BeneficiariesProvider = ({ children }) => {
  const { isAuthenticated } = useContext(AuthContext); // 로그인 상태 확인
  const [beneficiariesData, setBeneficiariesData] = useState([]);

  useEffect(() => {
    if (!isAuthenticated) return; // 로그인하지 않았으면 fetch 안 함

    const fetchBeneficiaries = async () => {
      try {
        const data = await BeneficiariesService.getBeneficiaries();
        setBeneficiariesData(data || []);
      } catch (error) {
        console.error("Error fetching beneficiaries data:", error);
      }
    };

    fetchBeneficiaries();
  }, [isAuthenticated]);

  const addBeneficiary = async (newItem) => {
    try {
      const addedItem = await BeneficiariesService.addBeneficiary(newItem);
      setBeneficiariesData((prevData) => [...prevData, addedItem]); // 기존 데이터에 추가
    } catch (error) {
      console.error("Error adding beneficiaries data:", error);
    }
  };

  const deleteBeneficiary = async (id) => {
    try {
      await BeneficiariesService.deleteBeneficiary(id);
      setBeneficiariesData((prevData) => prevData.filter((item) => item.id !== id));
    } catch (error) {
      console.error("Error deleting beneficiaries data:", error);
    }
  };

  const updateBeneficiary = async (id, updatedItem) => {
    try {
      const updatedData = await BeneficiariesService.updateBeneficiary(id, updatedItem);
      setBeneficiariesData((prevData) =>
        prevData.map((item) => (item.id === id ? updatedData : item))
      );
    } catch (error) {
      console.error("Error updating beneficiaries data:", error);
    }
  };

  return (
    <BeneficiariesContext.Provider value={{ beneficiariesData, setBeneficiariesData, addBeneficiary, deleteBeneficiary, updateBeneficiary }}>
      {children}
    </BeneficiariesContext.Provider>
  );
};
